// extracted by mini-css-extract-plugin
export default {"tableSection":"tableSection__ONRHf","tableRow":"tableRow__Bwn-X","modal":"modal__ByKJN"};